<template>
    <BreadCrumb PageTitle="Import factures électricité (Excel)" />
    <ImportationFacturesElectriciteExcel />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ImportationFacturesElectriciteExcel from "@/components/Importation/ImportationFacturesElectriciteExcel.vue";

export default defineComponent({
    name: "ImportationFacturesElectriciteExcelPage",
    components: {
        BreadCrumb,
        ImportationFacturesElectriciteExcel,
    },
});
</script>
